import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

interface ToggleGroupProps {
  title: string;
  children: React.ReactNode;
  columns?: 1 | 2;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(0.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  grid: {
    display: 'grid',
    gap: theme.spacing(1.5, 4),
  },
  gridTwoColumns: {
    position: 'relative' as const,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: '50%',
      width: '1px',
      backgroundColor: theme.palette.divider,
    },
  },
}));

const ToggleGroup: React.FC<ToggleGroupProps> = ({ title, children, columns = 2 }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>{title}</Typography>
      <div
        className={`${classes.grid} ${columns === 2 ? classes.gridTwoColumns : ''}`}
        style={{ gridTemplateColumns: columns === 2 ? '1fr 1fr' : '1fr' }}
      >
        {children}
      </div>
    </Box>
  );
};

export default ToggleGroup;
